export const LAST_VISITED_URL_KEY = "last-visited-url";
